// ✅ CheckInPage.js — Visitor Check-In Screen (UI Only)
// Premium Gradient Style — 2025-11-22

import React, { useState } from "react";
import MultiSelectDropdown from "../components/MultiSelectDropdown";

function CheckInPage() {
  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);

  const visitors = [
    {
      id: 1,
      name: "Rajesh Kumar",
      company: "XYZ Corp",
      host: "Manish",
      visitDate: "Today",
      status: "Approved",
    },
    {
      id: 2,
      name: "Anita Sharma",
      company: "ABC Pvt Ltd",
      host: "Happy",
      visitDate: "Today",
      status: "Approved",
    },
  ];

  const filtered = visitors.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid py-3">
      
      {/* HEADER */}
      <div
        className="p-4 mb-4 shadow-sm"
        style={{
          borderRadius: "20px",
          background:
            "linear-gradient(95deg,#4f46e5 0%,#6366f1 40%,#0ea5e9 100%)",
          color: "#fff",
        }}
      >
        <h3 className="fw-bold mb-1">Visitor Check-In</h3>
        <small className="opacity-75">Scan QR or search visitor to check-in</small>
      </div>

      {/* SEARCH BAR */}
      <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "20px" }}>
        <div className="card-body d-flex gap-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search visitor / company / host..."
            style={{
              borderRadius: "999px",
              padding: "0.85rem 1.2rem",
              border: "1px solid #e5e7eb",
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* LIST OF VISITORS */}
      <div className="card shadow-sm" style={{ borderRadius: "20px" }}>
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Visitor</th>
                <th>Company</th>
                <th>Host</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((v, i) => (
                <tr key={v.id}>
                  <td>{i + 1}</td>
                  <td>{v.name}</td>
                  <td>{v.company}</td>
                  <td>{v.host}</td>
                  <td>{v.visitDate}</td>
                  <td>
                    <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill">
                      {v.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn btn-success btn-sm fw-semibold px-3 rounded-pill"
                      onClick={() => alert("Checked-In (UI Only)")}
                    >
                      Check-In
                    </button>
                  </td>
                </tr>
              ))}

              {filtered.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-4">
                    No visitors found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}

export default CheckInPage;
